import { db } from '../firebase/config';
import { 
  collection, 
  doc, 
  getDoc, 
  setDoc, 
  updateDoc, 
  query, 
  where, 
  getDocs,
  Timestamp,
  serverTimestamp,
  increment
} from 'firebase/firestore';
import { VIP_CONFIG } from './optimizationService';
import { getUserById, updateUserData } from '../firebase/helpers';

/**
 * Product catalog with matching images and titles
 * Each product has an image path and a matching title
 */
const PRODUCT_CATALOG = [
  { image: '/optimization-images/1st.jpg', title: 'Fashionable Crossbody Bag' },
  { image: '/optimization-images/2nd.jpg', title: 'Track Suit' },
  { image: '/optimization-images/3rd.jpg', title: 'Classic Leather Briefcase' },
  { image: '/optimization-images/4th.jpg', title: 'Toy' },
  { image: '/optimization-images/5th.jpg', title: 'Track Suit' },
  { image: '/optimization-images/6th.jpg', title: 'Smart Air Purifier' },
  { image: '/optimization-images/7th.jpg', title: 'Trouser Shirt' },
  { image: '/optimization-images/8th.jpg', title: 'Wireless Charging Pad' },
  { image: '/optimization-images/9th.jpg', title: 'Smart Water Bottle' },
  { image: '/optimization-images/10th.jpg', title: 'Smart Fitness Tracker Watch' },
  { image: '/optimization-images/11th.jpg', title: 'Smart Fitness Tracker Watch' },
  { image: '/optimization-images/12th.jpg', title: 'Luxury Sports Watch' },
  { image: '/optimization-images/13th.jpg', title: 'Laptop Bag' },
  { image: '/optimization-images/14th.jpg', title: 'Premium Leather Wallet' },
  { image: '/optimization-images/15th.jpg', title: 'Lipsticks' },
  { image: '/optimization-images/16th.jpg', title: 'Key Locker' },
  { image: '/optimization-images/17th.jpg', title: 'Women Track Suit' },
  { image: '/optimization-images/18th.jpg', title: 'Designer Handbag Leather' },
  { image: '/optimization-images/19th.jpg', title: 'Noise Cancelling Earbuds' },
  { image: '/optimization-images/20th.jpg', title: 'Premium Wireless Headphones' },
  { image: '/optimization-images/21th.jpg', title: 'Premium Kitchen Appliances' },
  { image: '/optimization-images/22th.jpg', title: 'HD Webcam with Microphone' },
  { image: '/optimization-images/23th.jpg', title: 'Professional Sports Equipment' },
  { image: '/optimization-images/24th.jpg', title: 'Ergonomic Office Chair' },
  { image: '/optimization-images/25th.jpg', title: 'Ergonomic Office Chair' },
  { image: '/optimization-images/26th.jpg', title: 'Ergonomic Office Chair' },
  { image: '/optimization-images/27th.jpg', title: 'Ergonomic Office Chair' },
  { image: '/optimization-images/28th.jpg', title: 'Ergonomic Office Chair' },
  { image: '/optimization-images/29th.jpg', title: 'Smart Home Security Camera' },
  { image: '/optimization-images/30th.jpg', title: 'Smart Scale Body Analyzer' },
  { image: '/optimization-images/31th.jpg', title: 'Smart Scale Body Analyzer' },
  { image: '/optimization-images/32th.jpg', title: 'Premium Wireless Headphones' },
  { image: '/optimization-images/33th.avif', title: 'Smart Thermostat' },
  { image: '/optimization-images/34th.avif', title: 'Premium Kitchen Appliances' },
  { image: '/optimization-images/35th.avif', title: 'Luxury Women\'s Handbag' },
  { image: '/optimization-images/36th.avif', title: 'Designer Shoulder Bag' },
  { image: '/optimization-images/37th.avif', title: 'Designer Handbag Leather' },
  { image: '/optimization-images/38th.avif', title: 'Home Appliances' },
  { image: '/optimization-images/39th.avif', title: 'Premium Kitchen Appliances' },
  { image: '/optimization-images/40th.avif', title: 'Luxury Women\'s Handbag' },
  { image: '/optimization-images/41th.avif', title: 'Premium Kitchen Appliances' },
  { image: '/optimization-images/42th.avif', title: 'Smart Thermostat' },
  { image: '/optimization-images/43th.avif', title: 'Premium Kitchen Appliances' },
  { image: '/optimization-images/44th.avif', title: 'Premium Kitchen Appliances' },
  { image: '/optimization-images/45th.avif', title: 'Premium Kitchen Appliances' },
  { image: '/optimization-images/46th.avif', title: 'Smart LED Light Bulb' },
  { image: '/optimization-images/47th.avif', title: 'Noise Cancelling Earbuds' },
  { image: '/optimization-images/48th.avif', title: 'HD Webcam with Microphone' },
  { image: '/optimization-images/49th.avif', title: 'Smart Fitness Tracker Watch' },
  { image: '/optimization-images/50th.avif', title: 'Computer Fan' },
  { image: '/optimization-images/51th.avif', title: 'Cup Set' },
  { image: '/optimization-images/52th.avif', title: 'High-Performance Sports Shoes' },
  { image: '/optimization-images/53th.avif', title: 'Smart Fitness Tracker Watch' },
  { image: '/optimization-images/54th.avif', title: 'Luxury Bath Accessories' },
  { image: '/optimization-images/55th.avif', title: 'Tech Accessories' },
  { image: '/optimization-images/56th.avif', title: 'Elegant Home Fragrance' },
  { image: '/optimization-images/57th.avif', title: 'Tomato Soup' },
  { image: '/optimization-images/58th.avif', title: 'Smart Water Bottle' },
  { image: '/optimization-images/59th.avif', title: 'Luxury Bath Accessories' },
  { image: '/optimization-images/60th.avif', title: 'HD Webcam with Microphone' },
  { image: '/optimization-images/61th.avif', title: 'Elegant Home Fragrance' },
  { image: '/optimization-images/62th.avif', title: 'Erbology' },
  { image: '/optimization-images/63th.avif', title: 'Wireless Mouse & Keyboard Set' },
  { image: '/optimization-images/64th.avif', title: 'Luxury Bath Accessories' },
  { image: '/optimization-images/65th.avif', title: 'Luxury Bath Accessories' },
  { image: '/optimization-images/66th.avif', title: 'Premium Yoga Mat Set' },
  { image: '/optimization-images/67th.avif', title: 'Premium Wireless Headphones' },
  { image: '/optimization-images/68th.avif', title: 'Luxury Bath Accessories' },
  { image: '/optimization-images/69th.avif', title: 'Luxury Watch' },
  { image: '/optimization-images/70th.avif', title: 'Home Wear Couple' }
];
  
/**
 * Get today's date key (YYYY-MM-DD format)
 */
const getTodayKey = () => {
  const now = new Date();
  return now.toISOString().split('T')[0];
};

/**
 * Generate unique task code
 */
export const generateTaskCode = () => {
  const timestamp = Date.now().toString(36).toUpperCase();
  const random = Math.random().toString(36).substring(2, 8).toUpperCase();
  return `TASK-${timestamp}-${random}`;
};

/**
 * Get random product (image and title together)
 */
export const getRandomProduct = () => {
  const randomIndex = Math.floor(Math.random() * PRODUCT_CATALOG.length);
  return PRODUCT_CATALOG[randomIndex];
};

/**
 * Get random product image (for backward compatibility)
 */
export const getRandomProductImage = () => {
  const product = getRandomProduct();
  return product.image;
};

/**
 * Get random product title (for backward compatibility)
 */
export const getRandomProductTitle = () => {
  const product = getRandomProduct();
  return product.title;
};

/**
 * Calculate task price based on user balance and VIP level
 */
export const calculateTaskPrice = (userBalance, vipLevel) => {
  const balance = parseFloat(userBalance) || 0;
  if (balance <= 0) return 0;

  // VIP-based percentage ranges
  const percentageRanges = {
    'VIP1': { min: 0.10, max: 0.30 }, // 10-30%
    'VIP2': { min: 0.15, max: 0.40 }, // 15-40%
    'VIP3': { min: 0.20, max: 0.50 }, // 20-50%
    'VIP4': { min: 0.25, max: 0.60 }, // 25-60%
  };

  const range = percentageRanges[vipLevel] || percentageRanges['VIP1'];
  const percentage = range.min + Math.random() * (range.max - range.min);
  const price = balance * percentage;
  
  // Round to 2 decimal places
  return Math.round(price * 100) / 100;
};

/**
 * Calculate commission based on price and VIP level
 */
export const calculateCommission = (price, vipLevel) => {
  const config = VIP_CONFIG[vipLevel] || VIP_CONFIG['VIP1'];
  const commissionRate = config.commission / 100; // Convert to decimal (0.4% = 0.004)
  const commission = price * commissionRate;
  
  // Round to 2 decimal places
  return Math.round(commission * 100) / 100;
};

/**
 * Generate products for knife amount (2-3 products that total to knife amount)
 */
const generateProductsForKnifeAmount = (knifeAmount) => {
  // Randomly choose 2 or 3 products
  const numProducts = Math.random() < 0.5 ? 2 : 3;
  const products = [];
  
  // Distribute knife amount across products
  if (numProducts === 2) {
    // Split equally or with slight variation
    const split1 = Math.floor(knifeAmount / 2 * 100) / 100;
    const split2 = Math.round((knifeAmount - split1) * 100) / 100;
    products.push({ price: split1 });
    products.push({ price: split2 });
  } else {
    // Split into 3 parts
    const part1 = Math.floor((knifeAmount / 3) * 100) / 100;
    const part2 = Math.floor((knifeAmount / 3) * 100) / 100;
    const part3 = Math.round((knifeAmount - part1 - part2) * 100) / 100;
    products.push({ price: part1 });
    products.push({ price: part2 });
    products.push({ price: part3 });
  }
  
  // Assign random products to each price
  products.forEach((product, index) => {
    const randomProduct = getRandomProduct();
    product.image = randomProduct.image;
    product.title = randomProduct.title;
    product.id = `product-${index + 1}`;
  });
  
  return products;
};

/**
 * Generate task data for user
 */
export const generateTaskData = async (userId) => {
  try {
    const user = await getUserById(userId);
    if (!user) {
      throw new Error('User not found');
    }

    const vipLevel = user.vipLevel || 'VIP1';
    const walletBalance = user.balances?.wallet || 0;
    
    // Check if user has pending knife assignment
    let knifeAmount = null;
    let products = null;
    try {
      const { getUserManualKnifeAssignment } = await import('./manualKnifeService');
      const assignment = await getUserManualKnifeAssignment(userId);
      if (assignment && assignment.status === 'pending') {
        knifeAmount = assignment.knifeAmount;
        // Generate products for knife amount
        products = generateProductsForKnifeAmount(knifeAmount);
      }
    } catch (knifeError) {
      console.log('No pending knife assignment or error checking:', knifeError);
    }
    
    // If knife is pending, use knife amount; otherwise calculate dynamic price
    const totalAmount = knifeAmount || calculateTaskPrice(walletBalance, vipLevel);
    
    // Calculate commission
    const commission = calculateCommission(totalAmount, vipLevel);
    
    // Generate product data
    let productImage, productTitle;
    if (products && products.length > 0) {
      // Use first product as main display (for backward compatibility)
      productImage = products[0].image;
      productTitle = products[0].title;
    } else {
      // Generate random product data (image and title together to ensure they match)
      const product = getRandomProduct();
      productImage = product.image;
      productTitle = product.title;
    }
    
    const taskCode = generateTaskCode();

    return {
      productImage,
      productTitle,
      products, // Array of products (for knife scenario)
      knifeAmount, // Knife amount if applicable
      totalAmount,
      commission,
      taskCode,
      vipLevel,
      createdAt: new Date().toISOString()
    };
  } catch (error) {
    console.error('Error generating task data:', error);
    throw error;
  }
};

/**
 * Handle task submission
 * Optimized for speed: Updates balance first, then runs other operations in parallel
 */
export const handleTaskSubmission = async (taskData, userId, taskNumber = null, vipLevel = 'VIP1') => {
  try {
    const user = await getUserById(userId);
    if (!user) {
      throw new Error('User not found');
    }

    // Check for negative balance
    if (user.hasNegativeBalance || (user.balances?.negative && user.balances.negative < 0)) {
      throw new Error('Account restricted: You have a negative balance. Please contact customer service to resolve this issue.');
    }

    const commission = parseFloat(taskData.commission) || 0;
    const currentWallet = parseFloat(user.balances?.wallet) || 0;
    const currentCommission = parseFloat(user.balances?.commission) || 0;
    const currentTodaysProfit = parseFloat(user.balances?.todaysProfit) || 0;

    // Update balances
    // Commission is added to wallet (wallet includes commission)
    // This matches the Dashboard display logic: displayBalance = wallet + commission
    // But since commission is already included in wallet, we only add to wallet
    const newWallet = currentWallet + commission;
    const newCommission = currentCommission + commission;
    // Total = Wallet (since commission is included in wallet)
    const newTotal = newWallet;
    const newTodaysProfit = currentTodaysProfit + commission;

    // CRITICAL: Update user balances first (this is what the user sees)
    // Add commission first, then check for knife
    await updateUserData(userId, {
      balances: {
        ...user.balances,
        wallet: newWallet,
        commission: newCommission,
        total: newTotal,
        todaysProfit: newTodaysProfit
      },
      updatedAt: Timestamp.now()
    });

    // Check for manual knife assignment AFTER commission is added
    // This way user gets commission, then knife is applied
    let manualKnifeResult = { applied: false };
    try {
      console.log('🔍 Checking for manual knife assignment for user:', userId);
      const { checkAndApplyManualKnife } = await import('./manualKnifeService');
      
      // Add timeout to knife check to prevent hanging
      const knifeCheckPromise = checkAndApplyManualKnife(userId);
      const knifeTimeoutPromise = new Promise((resolve) => 
        setTimeout(() => resolve({ applied: false, reason: 'Timeout' }), 10000)
      );
      
      manualKnifeResult = await Promise.race([knifeCheckPromise, knifeTimeoutPromise]);
      console.log('🔍 Manual knife check completed, result:', manualKnifeResult);
      
      if (manualKnifeResult && manualKnifeResult.applied) {
        console.log('🔪 Manual knife applied on task submission:', manualKnifeResult);
        
        // Run ALL background tasks (non-blocking) - don't wait for these
        Promise.all([
          // Record task submission (with knife)
          (async () => {
            try {
              const taskRef = doc(collection(db, 'taskSubmissions'));
              const taskRecord = {
                userId: userId,
                userEmail: user.email || '',
                vipLevel: user.vipLevel || 'VIP1',
                productImage: taskData.productImage,
                productTitle: taskData.productTitle,
                totalAmount: taskData.totalAmount,
                commission: commission,
                taskCode: taskData.taskCode,
                createdAt: serverTimestamp(),
                date: getTodayKey(),
                status: 'pending', // Pending when knife is active
                knifeApplied: true
              };
              
              // Save all products if knife was active
              if (taskData.products && taskData.products.length > 0) {
                taskRecord.products = taskData.products;
                taskRecord.knifeAmount = taskData.knifeAmount;
              }
              
              await setDoc(taskRef, taskRecord);
              console.log('✅ Task submission recorded (with knife)');
            } catch (err) {
              console.error('Error recording task submission:', err);
            }
          })(),
          // Update daily profit tracking
          updateDailyProfit(userId, commission, taskData).catch(err => {
            console.error('Error updating daily profit:', err);
          }),
          // Track user activity and update task progress (with timeout)
          (async () => {
            if (taskNumber) {
              try {
                import('./userActivityService').then(({ trackUserActivity }) => {
                  trackUserActivity(userId, 'task_completion').catch(err => {
                    console.error('Error tracking user activity:', err);
                  });
                });
                
                // Add timeout to prevent hanging
                const progressPromise = (async () => {
                  const { updateUserTaskOptimization } = await import('./autoKnifeTriggerService');
                  return await updateUserTaskOptimization(userId, taskNumber, 1);
                })();
                
                const progressTimeout = new Promise((resolve) => 
                  setTimeout(() => resolve({ success: false, error: 'Timeout' }), 5000)
                );
                
                await Promise.race([progressPromise, progressTimeout]);
              } catch (err) {
                console.error('Error updating task progress:', err);
              }
            }
          })()
        ]).catch(err => {
          console.error('Error in background tasks:', err);
        });
        
        // Return IMMEDIATELY with knife result - user will be redirected
        console.log('✅ Returning knife result immediately');
        return {
          success: true,
          newWallet: manualKnifeResult.newWallet,
          newCommission: newCommission,
          newTotal: manualKnifeResult.newTotal,
          newTodaysProfit: newTodaysProfit,
          commission: commission,
          manualKnifeApplied: true,
          knifeResult: manualKnifeResult
        };
      }
    } catch (knifeError) {
      console.error('Error checking manual knife:', knifeError);
      // Continue with normal task submission even if knife check fails
    }

    // Record task submission (for normal case - no knife)
    try {
      const taskRef = doc(collection(db, 'taskSubmissions'));
      const taskRecord = {
        userId: userId,
        userEmail: user.email || '',
        vipLevel: user.vipLevel || 'VIP1',
        productImage: taskData.productImage,
        productTitle: taskData.productTitle,
        totalAmount: taskData.totalAmount,
        commission: commission,
        taskCode: taskData.taskCode,
        createdAt: serverTimestamp(),
        date: getTodayKey(),
        status: 'completed' // Default status
      };
      
      // If knife was active, save all products
      if (taskData.products && taskData.products.length > 0) {
        taskRecord.products = taskData.products;
        taskRecord.knifeAmount = taskData.knifeAmount;
        taskRecord.status = 'pending'; // Set to pending when knife is active
      }
      
      await setDoc(taskRef, taskRecord);
      console.log('✅ Task submission recorded');
    } catch (err) {
      console.error('Error recording task submission:', err);
      // Don't throw - continue even if recording fails
    }

    // NON-CRITICAL: Run these operations in background (don't block UI)
    Promise.all([
      // Update daily profit tracking
      updateDailyProfit(userId, commission, taskData).catch(err => {
        console.error('Error updating daily profit:', err);
      }),
      // Track user activity and update task progress (with timeout)
      (async () => {
        if (taskNumber) {
          try {
            // Track user activity (non-blocking)
            import('./userActivityService').then(({ trackUserActivity }) => {
              trackUserActivity(userId, 'task_completion').catch(err => {
                console.error('Error tracking user activity:', err);
              });
            });
            
            // Update task optimization count (for progress tracking only) with timeout
            const progressPromise = (async () => {
              const { updateUserTaskOptimization } = await import('./autoKnifeTriggerService');
              return await updateUserTaskOptimization(userId, taskNumber, 1);
            })();
            
            const progressTimeout = new Promise((resolve) => 
              setTimeout(() => resolve({ success: false, error: 'Timeout' }), 5000)
            );
            
            await Promise.race([progressPromise, progressTimeout]);
          } catch (err) {
            console.error('Error updating task progress:', err);
          }
        }
      })()
    ]).catch(err => {
      console.error('Error in background tasks:', err);
    });

    // Return immediately after balance update
    console.log('✅ Task submission completed successfully (no knife applied)');
    return {
      success: true,
      newWallet,
      newCommission,
      newTotal,
      newTodaysProfit,
      commission,
      manualKnifeApplied: false
    };
  } catch (error) {
    console.error('Error handling task submission:', error);
    throw error;
  }
};

/**
 * Update daily profit tracking
 */
export const updateDailyProfit = async (userId, commission, taskData) => {
  try {
    const todayKey = getTodayKey();
    const profitRef = doc(db, 'dailyProfits', `${userId}_${todayKey}`);
    const profitDoc = await getDoc(profitRef);

    const taskEntry = {
      taskCode: taskData.taskCode,
      productTitle: taskData.productTitle,
      totalAmount: taskData.totalAmount,
      commission: commission,
      timestamp: serverTimestamp()
    };

    if (profitDoc.exists()) {
      const data = profitDoc.data();
      const currentTotal = parseFloat(data.totalProfit) || 0;
      const currentTasks = data.taskBreakdown || [];
      
      await updateDoc(profitRef, {
        totalProfit: currentTotal + commission,
        tasksCompleted: (data.tasksCompleted || 0) + 1,
        taskBreakdown: [...currentTasks, taskEntry],
        updatedAt: serverTimestamp()
      });
    } else {
      await setDoc(profitRef, {
        userId: userId,
        date: todayKey,
        totalProfit: commission,
        tasksCompleted: 1,
        taskBreakdown: [taskEntry],
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      });
    }
  } catch (error) {
    console.error('Error updating daily profit:', error);
    // Don't throw - this is not critical for task submission
  }
};

/**
 * Get daily profit for user
 */
export const getDailyProfit = async (userId, date = null) => {
  try {
    const dateKey = date || getTodayKey();
    const profitRef = doc(db, 'dailyProfits', `${userId}_${dateKey}`);
    const profitDoc = await getDoc(profitRef);

    if (!profitDoc.exists()) {
      return {
        date: dateKey,
        totalProfit: 0,
        tasksCompleted: 0,
        taskBreakdown: []
      };
    }

    const data = profitDoc.data();
    return {
      date: data.date || dateKey,
      totalProfit: parseFloat(data.totalProfit) || 0,
      tasksCompleted: data.tasksCompleted || 0,
      taskBreakdown: data.taskBreakdown || []
    };
  } catch (error) {
    console.error('Error getting daily profit:', error);
    throw error;
  }
};

/**
 * Get user's task history
 */
export const getUserTaskHistory = async (userId, limit = 50) => {
  try {
    const q = query(
      collection(db, 'taskSubmissions'),
      where('userId', '==', userId)
    );
    
    const querySnapshot = await getDocs(q);
    const tasks = [];
    
    querySnapshot.forEach((doc) => {
      tasks.push({
        id: doc.id,
        ...doc.data()
      });
    });
    
    // Sort by creation time (newest first)
    tasks.sort((a, b) => {
      const timeA = a.createdAt?.toDate?.() || new Date(0);
      const timeB = b.createdAt?.toDate?.() || new Date(0);
      return timeB - timeA;
    });
    
    return tasks.slice(0, limit);
  } catch (error) {
    console.error('Error getting task history:', error);
    throw error;
  }
};

